import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";
import isEmpty from "assets/scripts/utils/isEmpty";
import { ERRORS, REQUIRED } from "../../../../constants/FormMessages";
import SelectFormGroup from "assets/scripts/components/common/form/SelectFormGroup/SelectFormGroup";
import TextFormGroup from "assets/scripts/components/common/form/TextFormGroup/TextFormGroup";
import getPasswordError from "assets/scripts/utils/getPasswordError";
const messages = defineMessages({
    securityQuestionLabel: {
        id: "forms.passwordCreate.securityQuestion.label",
        defaultMessage: "Security question"
    },
    securityQuestionNullOption: {
        id: "forms.passwordCreate.securityQuestion.nullOption",
        defaultMessage: "Select a Security Question"
    },
    securityAnswerLabel: {
        id: "forms.passwordCreate.securityAnswer.label",
        defaultMessage: "Security answer"
    },
    passwordLabel: {
        id: "forms.passwordCreate.password.label",
        defaultMessage: "New password"
    },
    passwordConfirmLabel: {
        id: "forms.passwordCreate.passwordConfirm.label",
        defaultMessage: "Confirm your password"
    }
});
export function getErrors(value) {
    const passwordValid = value.password.length > 0;
    const passwordConfirmValid = value.passwordConfirm.length > 0;
    const passwordsMatch = value.password === value.passwordConfirm;
    return {
        securityQuestion: isEmpty(value.securityQuestion) ? ERRORS.SELECT : null,
        securityAnswer: isEmpty(value.securityAnswer) ? REQUIRED : null,
        password: getPasswordError(passwordValid, passwordConfirmValid, passwordsMatch),
        passwordConfirm: getPasswordError(passwordConfirmValid, passwordValid, passwordsMatch)
    };
}
export default function PasswordCreateInputs(props) {
    const { value, errors, backendErrors } = props;
    const handleUpdate = (update) => props.onChange({
        ...value,
        ...update
    });
    const securityQuestionOptions = [
        {
            value: "",
            label: messages.securityQuestionNullOption
        },
        ...props.securityQuestions.questions.map(({ id, question, questionES }) => ({
            value: id.toString(),
            label: props.locale === "es" ? questionES : question
        }))
    ];
    return (<fieldset className="fieldset">
			<legend>
				<span className="u-isVisuallyHidden">
					<FormattedMessage id="forms.passwordCreate.legend" defaultMessage="Security Information"/>
				</span>
			</legend>

			<SelectFormGroup name="securityQuestion" label={messages.securityQuestionLabel} value={value.securityQuestion} onChange={securityQuestion => handleUpdate({ securityQuestion })} error={errors.securityQuestion} backendError={backendErrors.securityQuestionId} required options={securityQuestionOptions}/>

			<TextFormGroup name="securityAnswer" label={messages.securityAnswerLabel} value={value.securityAnswer} onChange={securityAnswer => handleUpdate({ securityAnswer })} error={errors.securityAnswer} backendError={backendErrors.securityAnswer} required inputProps={{
        autoComplete: "security-answer"
    }}/>

			<TextFormGroup name="password" type="password" label={messages.passwordLabel} value={value.password} onChange={password => handleUpdate({ password })} error={errors.password} backendError={backendErrors.password} required inputProps={{
        autoComplete: "new-password"
    }}/>

			<TextFormGroup name="passwordConfirm" type="password" label={messages.passwordConfirmLabel} value={value.passwordConfirm} onChange={passwordConfirm => handleUpdate({ passwordConfirm })} error={errors.passwordConfirm} required inputProps={{
        autoComplete: "new-password"
    }}/>
		</fieldset>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/forms/public/PasswordCreateInputs/PasswordCreateInputs.tsx